module.exports = {"130730100":"沙城镇","130730101":"北辛堡镇","130730102":"新保安镇","130730103":"东花园镇","130730104":"官厅镇","130730105":"桑园镇","130730106":"存瑞镇","130730107":"土木镇","130730108":"大黄庄镇","130730109":"西八里镇","130730110":"小南辛堡镇","130730200":"狼山乡","130730203":"鸡鸣驿乡","130730205":"东八里乡","130730207":"瑞云观乡","130730208":"孙庄子乡","130730210":"王家楼回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130730.json
// module id = 193
// module chunks = 0